$(document).ready(function () {
    // Toggle short and long versions of text
    $(".show-more-text").click(function () {
        $(this).closest('.description-text').find('.short-text').hide();
        $(this).closest('.description-text').find('.long-text').show();
        return false;
    });
    $(".show-less-text").click(function () {
        $(this).closest('.description-text').find('.short-text').show();
        $(this).closest('.description-text').find('.long-text').hide();
        var descriptionTextElement = $(this).closest('.description-text');
        var megaMenuHeight = $('body .mega-menu-wrapper').length > 0 ? $('body .mega-menu-wrapper').outerHeight() : 0;
        var headerWrapperHeight = $('.header-wrapper').length > 0 ? $('.header-wrapper').outerHeight() : 0;
        var headerHeight = $('.site-header').length > 0 ? $('.site-header').outerHeight() : 0;

        $('html, body').animate({ scrollTop: descriptionTextElement.offset().top - megaMenuHeight - headerWrapperHeight - headerHeight }, 1000);
        return false;
    });
});